/**
 * The Focus chime — two short sine tones synthesized with Web Audio, so no
 * audio asset ships. Falling for "focus done", rising for "break over".
 *
 * Browsers only start an AudioContext from a user gesture: `primeChime()`
 * belongs inside the click that turns sound on, after which a phase change
 * can play without one.
 */
let ctx: AudioContext | null = null;

function context(): AudioContext | null {
  if (ctx) return ctx;
  const Ctor =
    window.AudioContext ??
    (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!Ctor) return null;
  ctx = new Ctor();
  return ctx;
}

export function primeChime(): void {
  const c = context();
  if (c && c.state === "suspended") void c.resume();
}

export function playChime(kind: "focus_end" | "break_end"): void {
  const c = context();
  if (!c) return;
  if (c.state === "suspended") void c.resume();
  const notes = kind === "focus_end" ? [880, 660] : [660, 880];
  notes.forEach((freq, i) => {
    const t0 = c.currentTime + 0.02 + i * 0.22;
    const osc = c.createOscillator();
    const gain = c.createGain();
    osc.type = "sine";
    osc.frequency.value = freq;
    gain.gain.setValueAtTime(0.0001, t0);
    gain.gain.exponentialRampToValueAtTime(0.18, t0 + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.4);
    osc.connect(gain).connect(c.destination);
    osc.start(t0);
    osc.stop(t0 + 0.45);
  });
}
